module.exports = __webpack_public_path__ + "img/Getintouch-right.1ce7b1cc.png";